import { put, select, takeLatest } from 'redux-saga/effects';
import { Selectors as RouterSelectors, Types as RouterTypes } from 'router';
import { Types as AuthTypes } from 'services/authentication';

export interface GetCollectionWatchOptions {
  parentUrlParam?: string;
  clear?: boolean;
  query?: { [key: string]: string };
}

type RequestAction = (args?: { clear?: boolean; query?: { [key: string]: string } }) => any;

function* triggerRequest(action: RequestAction, options: GetCollectionWatchOptions, signIn: boolean) {
  // If we don't specify parent param, trigger every time. We should only run on
  // sign in, in this case.
  if (!options.parentUrlParam) {
    return yield put(action({ clear: options.clear, query: options.query }));
  }

  const parentId = yield select(RouterSelectors.getParam, options.parentUrlParam);
  // If parentId is not specified, exit.
  if (!parentId) {
    return;
  }

  // Don't bother checking for previous on signIn.
  if (signIn) {
    return yield put(action({ clear: options.clear, query: options.query }));
  }

  const lastid = sessionStorage.getItem(`last-collection-${options.parentUrlParam}`) || 'noKey';
  if (lastid !== parentId) {
    sessionStorage.setItem(`last-collection-${options.parentUrlParam}`, parentId);
    return yield put(action({ clear: options.clear, query: options.query }));
  }
}

export function newGetCollectionWatchSaga(action: RequestAction, options: GetCollectionWatchOptions) {
  return function*() {
    yield takeLatest(AuthTypes.POPULATE_USER, () => triggerRequest(action, options, true));
    if (!!options.parentUrlParam) {
      yield takeLatest(RouterTypes.LOCATION_CHANGED, () => triggerRequest(action, options, false));
    }
  };
}
